
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'

export default class VectorImage extends React.Component {
  static propTypes = {
    source: PropTypes.object,
    width: PropTypes.string,
    height: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    align: PropTypes.oneOf(['left', 'right'])
  }

  static defaultProps = {
    source: {
      content: null,
      attributes: null
    }
  }

  render() {
    const {source, width, height, className, onClick} = this.props
    const markup = {__html: source.content}
    const attributes = source.attributes

    if (!attributes) return null

    return (
      <svg
        width={width}
        height={height}
        className={className}
        viewBox={attributes['viewBox']}
        dangerouslySetInnerHTML={markup}
        preserveAspectRatio={this.getAspectRatio()}
        onClick={onClick}
      />
    )
  }

  getAspectRatio() {
    const {align} = this.props

    switch (align) {
      case 'left':
        return 'xMinYMid'
      case 'right':
        return 'xMaxYMid'
      default:
        return 'xMidYMid'
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/VectorImage/index.js